import React, { useEffect, useState } from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend } from 'recharts';
import axios from 'axios';
import {getDatabaseStatsGridData} from "../../WorkDashboard/WorkDashboardStats/WorkDashboardStatsClient";
import {getContractM4mktPie} from "../../Contract/ContractClient";

// const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];
// const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#AF19FF', '#FF4560', '#26A69A', '#8B572A', '#D0021B', '#F8E71C'];
// const COLORS = ["rgb(30,144,255)","rgb(69,177,232)","rgb(135,206,250)","rgb(137,207,240)","rgb(173,216,230)","rgb(135,206,235)","rgb(231,254,255)","rgb(244,240,236)","rgb(250,250,250)"]
// const COLORS = ['rgb(30,144,255)','rgb(69,177,232)','rgb(135,206,250)','rgb(137,207,240)','rgb(173,216,230)','rgb(135,206,235)','rgb(231,254,255)','rgb(244,240,236)','rgb(250,250,250)']

const COLORS = [
    '#1E90FF', // rgb(30,144,255)
    '#45B1E8', // rgb(69,177,232)
    '#87CEFA', // rgb(135,206,250)
    '#89CFF0', // rgb(137,207,240)
    '#ADD8E6', // rgb(173,216,230)
    '#87CEEB', // rgb(135,206,235)
    '#E7FEFF', // rgb(231,254,255)
    '#F4F0EC', // rgb(244,240,236)
    '#FAFAFA'  // rgb(250,250,250)
];
const ContractM4mktPieChart = () => {



    const [M4mktPieData, setM4mktPieData] = useState([]);


    const fetchContractM4mktPie = () =>
        getContractM4mktPie()

            .then(data => {
                const formattedData = data.map(item => ({
                    name: item.breakField,
                    // value: parseInt(item.count, 10),
                    value: item.countField
                }));
                console.log("M4mkt pie chart data", formattedData);
                setM4mktPieData(formattedData);
            })
            .catch(error => {
                console.error('Error fetching data', error);
            });
    useEffect(() => {
        fetchContractM4mktPie();
    }, []);

    return (
        <div>
            <PieChart width={400} height={400}>
                <Pie
                    data={M4mktPieData}
                    cx="50%"
                    cy="50%"
                    // cx={200}
                    // cy={200}
                    outerRadius={150}
                    fill="#8884d8"
                    dataKey="value"
                    label={"Contract M4mkt"}
                >
                    {M4mktPieData.map((entry, index) => (
                        // <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]}/>
                        // <Cell key={`cell-${index}`} fill={`url(#color${index})`} />
                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                    ))}
                </Pie>
                <Tooltip/>
                <Legend>Contract M4mkt</Legend>
            </PieChart>
        </div>
    );
};

export default ContractM4mktPieChart;
